export default "__VITE_ASSET__fa6d5a9a__"